import common from './common'
import metrics from './metrics'

export default {
  namespaced: true,
  modules: {
    common,
    metrics
  }
}
